import React, { useEffect } from 'react';
import styled from 'styled-components';
import 'react-telephone-input/css/default.css';
import { ReactTelephoneInput } from 'react-telephone-input';
import { Input as AntdInput, Row } from 'antd';
import { replace } from 'lodash';

const Input = styled(AntdInput)`
  border-width: 0;
  font-weight: 500;
  font-size: 30px;
  width: calc(100% - 5em);
  border-radius: 0 0.4em 0.4em 0;
  padding: 0.16em 0.58em 0.14em 0.5em;
  text-align: left;

  :focus {
    outline: none;
  }

  :focus-visible {
    outline: 3px solid #008939;
    outline-offset: 2px;
    box-shadow: none;
  }

  display: inline-block;
  transition: all 300ms;
`;

const StyledPhoneInput = styled(ReactTelephoneInput)`
  font-family: "Aimo Sans";

  &.react-tel-input {
    display: inline-block;
    position: relative;
    color: rgba(0, 0, 0, 0.85);
    font-size: 30px;
    width: 5em;

    .flag-dropdown {
      width: 100%;
      display: flex;
      align-items: center;
      border-radius: 0.5em 0 0 0.5em;

      &:hover .selected-flag {
        background-color: transparent;
      }

      .selected-flag {
        background: transparent;
        border: none;
        width: 100%;
        height: 100%;
        border-radius: 0.5em 0 0 0.5em;

        .arrow {
          position: relative;
          top: 50%;
          margin-top: -0.2em;
          border-left: 0.4em solid transparent;
          border-right: 0.4em solid transparent;
          border-top: 0.4em solid #555;
        }

        .arrow.up {
          border-top: none;
          border-bottom: 0.4em solid #555;
        }
      }
    }

    .country-list {
      top: 2.7em;
      width: 300% !important;
      font-size: 20px;

      .country {
        position: relative !important;

        &:not(:last-child) {
          margin-bottom: -40px;
        }
      }

      .country-name {
        margin-right: 6px;
        color: #555;
      }
    }

    input[type='text'], input[type='tel'] {
      position: relative;
      z-index: 0;
      padding-left: 44px;
      padding-right: 15px;
      margin-left: 0;
      border-width: 0;
      border-radius: 0.5em 0 0 0.5em;
      text-align: right;
      font-weight: 500;
      font-size: 25px;
      font-family: "Aimo Sans";
      transition: all 300ms;

      width: 100%;
      display: inline-block;
      height: 100%;
    }
  }
`;

const getDefaultCode = country => {
  if (country === 'FI') {
    return '+358';
  }
  if (country === 'NO') {
    return '+47';
  }
  return '+46';
};

const InputPhone = ({
  value,
  onChange,
  phoneCode,
  setPhoneCode,
  defaultCountry,
  onBlur,
  phoneCountrySelectAriaLabel,
  ...rest
}) => {
  const resolvedCountry = (defaultCountry ?? 'SE').toString().toLowerCase();

  useEffect(() => {
    setPhoneCode(getDefaultCode(defaultCountry));
  }, [ defaultCountry, setPhoneCode ]);

  const countryInputProps = {
    readOnly: true,
    ...(phoneCountrySelectAriaLabel ? { 'aria-label': phoneCountrySelectAriaLabel } : {}),
  };

  return <Row flex="none">
    <StyledPhoneInput
      defaultCountry={resolvedCountry}
      flagsImagePath="/flags.png"
      preferredCountries={[ 'fi', 'se', 'no' ]}
      value={phoneCode}
      onChange={setPhoneCode}
      inputProps={countryInputProps}
      autoFormat={false}
    />
    <Input
      className="input-phone"
      type="tel"
      {...rest}
      value={value}
      onInput={e => e.target.value = replace(e.target.value, /\D+/g, '')}
      onChange={e => onChange(e.target.value)}
      onBlur={onBlur}
    />
  </Row>;
};

export default InputPhone;
